import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

/**
 * Floating Help Button Component
 * Renders a fixed-position FAB in the bottom-right corner.
 * Emits click events to the parent to toggle the help sidebar.
 * When a tutorial was dismissed mid-way, it advertises a "resume" state
 * (badge + label) so users know they can pick up where they left off.
 */
@Component({
  selector: 'app-floating-help-button',
  templateUrl: './floating-help-button.component.html',
  styleUrls: ['./floating-help-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FloatingHelpButtonComponent {
  /** Whether a dismissed tutorial can be resumed from a saved step */
  @Input() canResume = false;

  /** Human-readable resume label, e.g. "Resume · Step 3 of 5" */
  @Input() resumeLabel = '';

  @Output() buttonClick = new EventEmitter<void>();

  /** Tooltip / aria text — reflects resume state when available */
  get tooltip(): string {
    return this.canResume
      ? (this.resumeLabel || 'Resume tutorial')
      : 'Help & Tutorials';
  }

  onClick(): void {
    this.buttonClick.emit();
  }
}
